module.exports = __webpack_public_path__ + "img/profile.be1bc980.svg";